import { FEATURE_TO_TITLE } from 'hooks/dialogs/cluster/constants';

import {
  AgentSetupBlock,
  AgentSetupBlockProps,
} from './_components/AgentSetupBlock';
import { AgentSetupCompleteBlock } from './_components/AgentSetupCompleteBlock';

type SetupProps = Pick<
  AgentSetupBlockProps,
  | 'checked'
  | 'onChange'
  | 'hasBeenInstalled'
  | 'readonly'
  | 'showCheckbox'
  | 'readonlyTooltip'
>;

type CompleteProps = {
  checked?: boolean;
};

const heading = FEATURE_TO_TITLE.omni;

export const AgentOmniSetup = (props: SetupProps) => {
  return (
    <AgentSetupBlock
      heading={heading}
      description="Extend your cluster across regions and cloud providers for additional compute capacity."
      isNestedBlock
      testId="agent-omni"
      {...props}
    />
  );
};

export const AgentOmniComplete = ({ checked }: CompleteProps) => {
  return (
    <AgentSetupCompleteBlock
      heading={heading}
      testId="agent-omni-complete"
      isNestedBlock
      checked={checked}
    />
  );
};
